import React from 'react';

import TrustedByBarSlice from '../../../components/slices/TrustedByBarSlice';
import HeroSlice from '../../../components/slices/HeroSlice';
import TestimonialsSlice from '../../../components/slices/TestimonialsSlice';
import FeaturesSlice from '../../../components/slices/FeaturesSlice';
//import PackagesBlockSlice from '../../../04_components/slices/packages/PackagesBlockSlice';
//import FAQslice from '../../../04_components/slices/faq/FAQslice';
import StatsSlice from '../../../components/slices/StatsSlice';
import TextBlockSlice from '../../../components/slices/TextBlockSlice';
import SingleMediaSlice from '../../../components/slices/SingleMediaSlice';
import MultipleMediaSlice from '../../../components/slices/MultipleMediaSlice';
import ProductsSlice from '../../../components/slices/products/ProductsSlice';
// import AdvertisementSlice from '../../../04_components/slices/AdvertisementSlice';

// new on portal
import TableSlice from '../../../components/slices/TableSlice';
import BigVideoWistiaSlice from '../../../components/slices/BigVideoWistiaSlice';
import BigWistiaSliceWithCopy from '../../../components/slices/BigWistiaSliceWithCopy';
import EventsSlice from '../../../components/slices/EventsSlice';
import Subtitle from '../../../components/slices/SubtitleSlice';

export const sliceComponentsHelper = slices => {
	let componentsToDisplay = [];
	componentsToDisplay =
		!slices || !slices.length
			? null
			: slices.map((slice, index) => {
					if (slice === null || !slice.type) return '';
					if (slice.type === 'hero_banner' || slice.type === 'hero_-_header')
						return <HeroSlice key={index} data={slice} />;
					if (slice.type === 'trusted_by_bar')
						return <TrustedByBarSlice key={index} />;
					if (slice.type === 'features_block')
						return <FeaturesSlice key={index} data={slice} />;
					if (slice.type === 'testimonials')
						return (
							<TestimonialsSlice
								key={index}
								testimonials={slice.testimonials}
							/>
						);
					//if (slice.type === 'advertisement') return <AdvertisementSlice key={index} content={slice.ad}/>
					//if (slice.type === 'packages') return <PackagesBlockSlice key={index} packages={slice.packages}/>
					//if (slice.type === 'faq_slice') return <FAQslice key={index} faqs={slice}/>
					if (slice.type === 'stats_block')
						return <StatsSlice key={index} stats={slice} />;
					if (slice.type === 'text_block')
						return <TextBlockSlice key={index} content={slice} />;
					if (slice.type === 'single_media_block')
						return <SingleMediaSlice key={index} content={slice} />;
					if (slice.type === 'multiple_media_blocks')
						return <MultipleMediaSlice key={index} content={slice} />;
					if (slice.type === 'single_product_listing')
						return (
							<ProductsSlice
								key={index}
								content={slice}
								products={slice.products}
							/>
						);
					if (slice.type === 'table')
						return <TableSlice key={index} rows={slice.rows} />;
					if (slice.type === 'big_video')
						return <BigVideoWistiaSlice key={index} url={slice.url} />;
					if (slice.type === 'big_video_with_copy')
						return (
							<BigWistiaSliceWithCopy
								key={index}
								url={slice.url}
								copy={slice.copy}
								title={slice.title}
							/>
						);
					if (slice.type === 'subtitle') return <Subtitle key={index} text={slice.text} />;
					if (slice.type === 'events')
						return <EventsSlice key={index} events={slice.events} />;
					return '';
			  });
	return componentsToDisplay;
};



// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-slice-helpers/SliceComponentsHelpers.js